// extracted by mini-css-extract-plugin
module.exports = {"root":"TermsOfService_root__kQUKJ","lastUpdated":"TermsOfService_lastUpdated__CDnfE"};